/** Plage civile inclusive `yyyy-MM-dd` (dialogue Rapport U3130). */
export function u3130IsValidCivilDateRange(start: string, end: string): boolean {
  const s = start.trim().slice(0, 10);
  const e = end.trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s) || !/^\d{4}-\d{2}-\d{2}$/.test(e)) return false;
  return e >= s;
}
